export const cultiveleplaisir = {
  body_background_color: '#E63E30',

  header_no_margin: true,

  logo_image_url: 'cultiveleplaisir.png',
  logo_height: 400,

  title_font: `'Roboto Condensed', sans-serif`,

  text_font: `'Roboto Condensed', sans-serif`,
  text_size: 16,
  text_lineheight: 23,

  button_color: '#E63E30',
  button_radius: 50,

  footer_font: `'Open Sans', sans-serif`,
  footer_border_color: '#eee',
}


export const cultiveleplaisirFeux = {
  ...cultiveleplaisir,
    body_background_color: '#b20838',

    logo_image_url: 'cultiveleplaisirFeux.png',
    header_full_height: true,

    number_hidden: true,
    token_hidden: true,

    title_font : 'cinzel',
    subtitle_font : 'cinzel',
    text_font : 'Montserra light',
    button_color : '#ff5c39',
    button_radius: 15,
    button_border_width: 2,
}